import { createEnv } from '@t3-oss/env-nextjs'
import { z } from 'zod'

export const env = createEnv({
  /*
   * Serverside Environment variables, not available on the client.
   * Will throw if you access these variables on the client.
   */
  server: {
    AUTH0_CLIENT_ID: z.string(),
    AUTH0_CLIENT_SECRET: z.string(),
    AUTH0_ISSUER_BASE_URL: z.string().optional(),
    AUTH0_DOMAIN: z.string().optional(),
    AUTH0_BASE_URL: z.string().optional(),
    APP_BASE_URL: z.string().optional(),
    AUTH0_AUDIENCE: z.string().optional(),
    AUTH0_SCOPE: z.string().optional(),
    AUTH0_SECRET: z.string(),
    AUTH0_M2M_CLIENT_ID: z.string(),
    AUTH0_M2M_CLIENT_SECRET: z.string(),
    AUTH0_M2M_BASE_URL: z.string(),
    GRAPHQL_API_URL: z.string(),
    REST_API_URL: z.string().optional(),
    HIGHLIGHT_SOURCEMAP_UPLOAD_API_KEY: z.string().optional(),
    TALO_REPORTS_URL: z.string(),
    SLACK_WEBHOOK_URL: z.string().optional(),
    TALO_ADMIN_URL: z.string().optional(),
  },

  /*
   * Environment variables available on the client (and server).
   *
   * 💡 You'll get typeerrors if these are not prefixed with NEXT_PUBLIC_.
   */
  client: {
    NEXT_PUBLIC_VERCEL_ENV: z
      .enum(['production', 'preview', 'development'])
      .default('development'),
    NEXT_PUBLIC_ANALYTICS_WRITE_KEY: z.string(),
    NEXT_PUBLIC_WS_URL: z.string(),
    NEXT_PUBLIC_HIGHLIGHT_PROJECT_ID: z.string(),
    NEXT_PUBLIC_API_MOCKING: z.string().optional(),
    NEXT_PUBLIC_TALO_REPORTS_URL: z.string(),
  },

  /*
   * Due to how Next.js bundles environment variables on Edge and Client,
   * we need to manually destructure them to make sure all are included in bundle.
   *
   * 💡 You'll get typeerrors if not all variables from `server` & `client` are included here.
   */
  runtimeEnv: {
    AUTH0_CLIENT_ID: process.env.AUTH0_CLIENT_ID,
    AUTH0_CLIENT_SECRET: process.env.AUTH0_CLIENT_SECRET,
    AUTH0_ISSUER_BASE_URL: process.env.AUTH0_ISSUER_BASE_URL,
    AUTH0_DOMAIN: process.env.AUTH0_DOMAIN,
    AUTH0_BASE_URL: process.env.AUTH0_BASE_URL,
    APP_BASE_URL: process.env.APP_BASE_URL,
    AUTH0_AUDIENCE: process.env.AUTH0_AUDIENCE,
    AUTH0_SCOPE: process.env.AUTH0_SCOPE,
    AUTH0_SECRET: process.env.AUTH0_SECRET,
    AUTH0_M2M_CLIENT_ID: process.env.AUTH0_M2M_CLIENT_ID,
    AUTH0_M2M_CLIENT_SECRET: process.env.AUTH0_M2M_CLIENT_SECRET,
    AUTH0_M2M_BASE_URL: process.env.AUTH0_M2M_BASE_URL,
    GRAPHQL_API_URL: process.env.GRAPHQL_API_URL,
    REST_API_URL: process.env.REST_API_URL,
    NEXT_PUBLIC_API_MOCKING: process.env.NEXT_PUBLIC_API_MOCKING,
    HIGHLIGHT_SOURCEMAP_UPLOAD_API_KEY:
      process.env.HIGHLIGHT_SOURCEMAP_UPLOAD_API_KEY,
    NEXT_PUBLIC_VERCEL_ENV: process.env.NEXT_PUBLIC_VERCEL_ENV,
    NEXT_PUBLIC_ANALYTICS_WRITE_KEY:
      process.env.NEXT_PUBLIC_ANALYTICS_WRITE_KEY,
    NEXT_PUBLIC_WS_URL: process.env.NEXT_PUBLIC_WS_URL,
    NEXT_PUBLIC_HIGHLIGHT_PROJECT_ID:
      process.env.NEXT_PUBLIC_HIGHLIGHT_PROJECT_ID,
    NEXT_PUBLISHABLE_KEY: process.env.PUBLISHABLE_KEY,
    NEXT_PRICING_TABLE_ID: process.env.PRICING_TABLE_ID,
    TALO_REPORTS_URL: process.env.TALO_REPORTS_URL,
    NEXT_PUBLIC_TALO_REPORTS_URL: process.env.NEXT_PUBLIC_TALO_REPORTS_URL,
    SLACK_WEBHOOK_URL: process.env.SLACK_WEBHOOK_URL,
    TALO_ADMIN_URL: process.env.TALO_ADMIN_URL,
  },
})
